import { checkPermission } from '@/router/guards.ts'

const TransactionModule = () => import('./TransactionModule.vue')
const TransactionIndex = () => import('./views/TransactionIndex.vue')

export const transactionRoute = {
  path: '/transactions',
  name: 'transaction',
  component: TransactionModule,
  meta: {
    title: 'transactions',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'transactions-index',
      component: TransactionIndex,
      meta: {
        permission: 'transaction.view',
      },
      beforeEnter: checkPermission('transaction.view'),
    },
  ],
}
